import { User, Star } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

interface Review {
  rating: number;
  comment: string;
  purchase_location: string;
  user_id: string;
  profiles: {
    username: string;
  };
}

interface ProductReviewsProps {
  reviews: Review[];
}

const ProductReviews = ({ reviews }: ProductReviewsProps) => {
  const { t } = useTranslation();

  if (!reviews?.length) return null;

  return (
    <div className="border-t pt-4">
      <h3 className="font-semibold mb-2">{t('products.reviews')}</h3>
      {reviews.map((review: Review) => (
        <div key={review.user_id} className="mb-4">
          <div className="flex items-center gap-2">
            <User className="w-4 h-4" />
            <Link 
              to={`/user/${review.user_id}`}
              className="text-primary hover:underline"
            >
              {review.profiles?.username}
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
            <span>{review.rating}/5</span>
          </div>
          <p>{review.comment}</p>
          {review.purchase_location && (
            <p className="text-sm text-muted-foreground">
              {t('products.purchasedAt')}: {review.purchase_location}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProductReviews;